// components/PreviewNotice.tsx — the explicit "this is a preview, the numbers on
// screen are placeholders" affordance (owner decision, slice-4-xl §2).
//
// Originally lived in features/live/ and served only the two Live pages. Promoted
// here when /videos was found to need the same thing and not have it: Videos renders
// the identical class of seeded data — including view counts like "128K views" on a
// platform with four accounts — so without this line it reads as a broken product
// rather than an unbuilt one. That was the whole argument for the notice on Live.
//
// The wording is passed in rather than baked: each surface lies in its own specific
// way, and a notice that names the wrong placeholders is its own small untruth.
import styled from 'styled-components';
import { Icon } from '@/icons';

const Notice = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 8px 12px;
  border-radius: ${({ theme }) => theme.radius.md};
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  background: ${({ theme }) => theme.color.glassBg};
  color: ${({ theme }) => theme.color.textMuted};
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.xs};

  svg { flex-shrink: 0; color: ${({ theme }) => theme.color.accentCyan}; }
`;

export function PreviewNotice({ text }: { text: string }) {
  return (
    <Notice role="note">
      <Icon name="info" size={14} />
      <span>{text}</span>
    </Notice>
  );
}
